module.exports = __webpack_public_path__ + "static/media/lunchspinner.d6685c66.png";